import { render, staticRenderFns } from "./ModalArtigo.vue?vue&type=template&id=165a02b4&scoped=true"
import script from "./ModalArtigo.vue?vue&type=script&lang=js"
export * from "./ModalArtigo.vue?vue&type=script&lang=js"
import style0 from "./ModalArtigo.vue?vue&type=style&index=0&id=165a02b4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "165a02b4",
  null
  
)

export default component.exports